module.exports = __webpack_public_path__ + "assets/219a560aabd1e338e027b7893a040d2a.ttf";